import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import { CoreFormsModule } from '@yourcause/common/core-forms';
import { CurrencyModule } from '@yourcause/common/currency';
import * as i3 from '@yourcause/common/typeahead-select';
import { TypeaheadSelectModule } from '@yourcause/common/typeahead-select';
import * as i2 from '@yourcause/common/input';
import { InputModule } from '@yourcause/common/input';

class CurrencyComponent {
    constructor() {
        this.tabIndex = 0;
        this.currencyOptions = [];
        this.amountChange = new EventEmitter();
        this.currencyChange = new EventEmitter();
        this.hasErrors = false;
        this.toggleCurrency = () => {
            this.hasToggled = !this.hasToggled;
            this.setIcons();
        };
    }
    get amountToShow() {
        if (this.canToggle) {
            return this.hasToggled ? this.equivalent : this.amount;
        }
        return this.amount;
    }
    get currencyToShow() {
        if (this.canToggle) {
            return this.hasToggled ? this.equivalentCurrency : this.currency;
        }
        return this.currency;
    }
    ngOnInit() {
        this.setIcons();
    }
    ngOnChanges(changes) {
        if (changes.currency || changes.canToggle) {
            this.setIcons();
        }
        if (changes.isDirtyOverride || changes.errors) {
            if (this.errors) {
                const numberOfErrors = Object.keys(this.errors).length;
                this.hasErrors = numberOfErrors > 0 && this.isDirtyOverride;
            }
            else {
                this.hasErrors = false;
            }
        }
    }
    setIcons() {
        this.leftIcon = this.currency ? {
            icon: this.formattingData[this.currencyToShow]?.symbol,
            isStaticText: true
        } : null;
        this.rightIcons = this.canToggle ?
            [{
                    icon: 'globe',
                    onIconClick: this.toggleCurrency
                }] :
            [];
    }
    handleAmountChange(event) {
        this.amount = event;
        this.amountChange.emit(event);
    }
    handleCurrencyChange(event) {
        if (this.currency !== event) {
            this.currencyChange.emit(event);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: CurrencyComponent, isStandalone: false, selector: "yc-currency", inputs: { name: "name", amount: "amount", equivalent: "equivalent", currency: "currency", equivalentCurrency: "equivalentCurrency", canToggle: "canToggle", tabIndex: "tabIndex", label: "label", disabled: "disabled", hideLabel: "hideLabel", description: "description", currencyOptions: "currencyOptions", currencyLocked: "currencyLocked", currencyData: "currencyData", isRequired: "isRequired", formattingData: "formattingData", errors: "errors", isDirtyOverride: "isDirtyOverride", customLabelIcon: "customLabelIcon", customLabelIconTooltip: "customLabelIconTooltip", customLabelIconClass: "customLabelIconClass" }, outputs: { amountChange: "amountChange", currencyChange: "currencyChange" }, usesOnChanges: true, ngImport: i0, template: "\n<div class=\"currency-wrapper align-items-end\"\n  [class.align-items-center]=\"hasErrors\">\n  <div class=\"me-3 flex-grow-1\">\n    <yc-input\n      [name]=\"name\"\n      [value]=\"amountToShow\"\n      [disabled]=\"disabled\"\n      [isDirtyOverride]=\"isDirtyOverride\"\n      [label]=\"label\"\n      [description]=\"description\"\n      [tabIndex]=\"tabIndex\"\n      [errors]=\"errors\"\n      [srOnlyLabel]=\"hideLabel\"\n      [addRequiredAsterisk]=\"isRequired\"\n      [leftIcon]=\"leftIcon\"\n      [isNumber]=\"true\"\n      [rightIcons]=\"rightIcons\"\n      [customLabelIcon]=\"customLabelIcon\"\n      [customLabelIconTooltip]=\"customLabelIconTooltip\"\n      [customLabelIconClass]=\"customLabelIconClass\"\n      [currencyData]=\"formattingData[currencyToShow]\"\n      (valueChange)=\"handleAmountChange($event)\">\n    </yc-input>\n  </div>\n  <div>\n    <ng-container *ngIf=\"!currencyLocked\">\n      <yc-typeahead-select\n        [value]=\"currencyToShow\"\n        [disabled]=\"disabled\"\n        [hideBorder]=\"!disabled\"\n        [items]=\"currencyOptions\"\n        [showClear]=\"false\"\n        (valueChange)=\"handleCurrencyChange($event)\">\n      </yc-typeahead-select>\n    </ng-container>\n    <div *ngIf=\"currencyLocked\"\n      class=\"add-margin-bottom\">\n      {{ currencyToShow }}\n    </div>\n  </div>\n</div>\n\n\n", styles: [".add-margin-bottom{margin-bottom:.75rem}.currency-wrapper{display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.InputComponent, selector: "yc-input", inputs: ["isNumber", "currencyData", "numberOfDecimals", "requireDecimal", "inputClass", "rounded", "noBorderRadius", "autofocus", "isLocked", "placeholder", "popoverText", "danger", "maxLength", "min", "max", "prefix", "suffix", "prefixSuffixFlexBasis", "showWordCount", "showCharCount", "disablePaste", "customMaskPattern", "customRegexPattern"] }, { kind: "component", type: i3.TypeaheadSelectComponent, selector: "yc-typeahead-select", inputs: ["items", "supportsNumericCollection", "numericCollectionType", "dropdownPosition", "notFoundText", "multi", "formatAsArray", "hideBorder", "placeholder", "isLocked", "noBorderRadius", "useEmptyArray", "loading", "useLabelTemplate", "showSelectAllThatApplyHelpText"], outputs: ["onItemAdded", "onItemRemoved"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-currency', standalone: false, template: "\n<div class=\"currency-wrapper align-items-end\"\n  [class.align-items-center]=\"hasErrors\">\n  <div class=\"me-3 flex-grow-1\">\n    <yc-input\n      [name]=\"name\"\n      [value]=\"amountToShow\"\n      [disabled]=\"disabled\"\n      [isDirtyOverride]=\"isDirtyOverride\"\n      [label]=\"label\"\n      [description]=\"description\"\n      [tabIndex]=\"tabIndex\"\n      [errors]=\"errors\"\n      [srOnlyLabel]=\"hideLabel\"\n      [addRequiredAsterisk]=\"isRequired\"\n      [leftIcon]=\"leftIcon\"\n      [isNumber]=\"true\"\n      [rightIcons]=\"rightIcons\"\n      [customLabelIcon]=\"customLabelIcon\"\n      [customLabelIconTooltip]=\"customLabelIconTooltip\"\n      [customLabelIconClass]=\"customLabelIconClass\"\n      [currencyData]=\"formattingData[currencyToShow]\"\n      (valueChange)=\"handleAmountChange($event)\">\n    </yc-input>\n  </div>\n  <div>\n    <ng-container *ngIf=\"!currencyLocked\">\n      <yc-typeahead-select\n        [value]=\"currencyToShow\"\n        [disabled]=\"disabled\"\n        [hideBorder]=\"!disabled\"\n        [items]=\"currencyOptions\"\n        [showClear]=\"false\"\n        (valueChange)=\"handleCurrencyChange($event)\">\n      </yc-typeahead-select>\n    </ng-container>\n    <div *ngIf=\"currencyLocked\"\n      class=\"add-margin-bottom\">\n      {{ currencyToShow }}\n    </div>\n  </div>\n</div>\n\n\n", styles: [".add-margin-bottom{margin-bottom:.75rem}.currency-wrapper{display:flex}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], amount: [{
                type: Input
            }], equivalent: [{
                type: Input
            }], currency: [{
                type: Input
            }], equivalentCurrency: [{
                type: Input
            }], canToggle: [{
                type: Input
            }], tabIndex: [{
                type: Input
            }], label: [{
                type: Input
            }], disabled: [{
                type: Input
            }], hideLabel: [{
                type: Input
            }], description: [{
                type: Input
            }], currencyOptions: [{
                type: Input
            }], currencyLocked: [{
                type: Input
            }], currencyData: [{
                type: Input
            }], isRequired: [{
                type: Input
            }], formattingData: [{
                type: Input
            }], errors: [{
                type: Input
            }], isDirtyOverride: [{
                type: Input
            }], customLabelIcon: [{
                type: Input
            }], customLabelIconTooltip: [{
                type: Input
            }], customLabelIconClass: [{
                type: Input
            }], amountChange: [{
                type: Output
            }], currencyChange: [{
                type: Output
            }] } });

class CurrencyControlModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CurrencyControlModule, declarations: [CurrencyComponent], imports: [CommonModule,
            InputModule,
            TypeaheadSelectModule,
            CoreFormsModule,
            CurrencyModule], exports: [CurrencyComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyControlModule, imports: [CommonModule,
            InputModule,
            TypeaheadSelectModule,
            CoreFormsModule,
            CurrencyModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        InputModule,
                        TypeaheadSelectModule,
                        CoreFormsModule,
                        CurrencyModule
                    ],
                    declarations: [
                        CurrencyComponent
                    ],
                    exports: [
                        CurrencyComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CurrencyComponent, CurrencyControlModule };
